import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { brand } from "@/data/mockData";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      {/* Floating WhatsApp button */}
      <a
        href={brand.whatsapp}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp Johnny"
        className="fixed bottom-24 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white inline-flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
      >
        <i className="fa-brands fa-whatsapp text-2xl" aria-hidden="true" />
      </a>
    </div>
  );
}
